module.exports=function(scope){ return `{
    "meta": {
        "ok": true,
        "code": 200,
        "mode": "dev",
        "message": "A FaceMap was created."
    },
    "data": {
        "creationStatus": 0,
        "errorMessageFromZoomServer": null,
        "errorStatusFromZoomServer": 0,       
        "faceMap": FACEMAP_VALUE,
        "faceMapType": 1,
        "isLowQuality": false
    }
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/webservice-v2/response/success/facemap-post.json.tpl